import React from 'react';
import { Button } from '@mui/material';
import { SVGS } from '@zonofi/zono-money-design-system';
import './order-successfull.scss';
import {
  sendWAEventToParent,
  useAppSelector,
} from '@zonofi/zono-money-helpers';
import { getCustomerInvite, getIsSimulation } from '@zonofi/zono-money-store';
import { useSearchParams } from 'react-router-dom';
import { onClickBackToWhatsapp } from '@zonofi/zono-money-whatsapp-stack';

export const OrderSuccessfull: React.FC = () => {
  const inviteDetails = useAppSelector(getCustomerInvite);
  const isSimulation = useAppSelector(getIsSimulation);
  const [params] = useSearchParams();
  const skuCount = Number(params?.get('skuCount'));
  const { seller, waConfig } = inviteDetails;
  const successType = params?.get('successType');

  return (
    <div
      className="order_successfull font-primary"
      style={{ background: '#fff' }}
    >
      <div className="icon">
        <img className="svg-icon" height={120} src={SVGS.OrderSuccess} alt="" />
      </div>
      <div className="content">
        <h4 className="font-primary-semibold">
          {successType === 'orderUpdated'
            ? 'Order updated successfully!'
            : 'Order submitted successfully!'}
        </h4>
        {skuCount !== 0 && (
          <p>
            {successType === 'order'
              ? `Your order for ${skuCount} SKU's has been submitted to ${seller?.name}.`
              : ''}
          </p>
        )}
      </div>
      <div className="btn_section">
        <Button
          disableRipple
          disableFocusRipple
          disableElevation
          sx={{ all: 'unset' }}
          className="backto_whatsapp font-primary-semibold"
          onClick={() =>
            onClickBackToWhatsapp({
              whatsappPhoneNo: waConfig?.whatsappPhoneNo,
              workspaceId: seller?.workspaceId,
              isSimulation: isSimulation,
              sendEventToParent: () => {
                sendWAEventToParent({ orderSuccessful: true });
              },
            })
          }
        >
          Back to WhatsApp
        </Button>
      </div>
    </div>
  );
};
